import { Text } from '@chakra-ui/react'
import { CatalogoBasePage, type ColumnConfig, type FieldConfig } from '../../../components/CatalogoBasePage'
import { componentCategoriesService } from '../../../api/services'
import type { ComponentCategoryItem } from '../../../api/models/maestros.models'
import { themeColors } from '../../../theme'

const columns: ColumnConfig<ComponentCategoryItem>[] = [
  { header: 'Código', render: (c) => <Text fontFamily="monospace" fontSize="sm" fontWeight="600" color={themeColors.text}>{c.code}</Text> },
  { header: 'Nombre', render: (c) => <Text fontSize="sm" color={themeColors.text}>{c.name}</Text> },
  { header: 'Descripción', render: (c) => <Text fontSize="sm" color={themeColors.textSecondary}>{c.description ?? '-'}</Text> },
  { header: 'Orden', render: (c) => <Text fontSize="sm" color={themeColors.textSecondary}>{c.sortOrder}</Text> },
]

const fields: FieldConfig<ComponentCategoryItem>[] = [
  { name: 'code', label: 'Código', type: 'text', required: true, placeholder: 'ej. explotacion' },
  { name: 'name', label: 'Nombre', type: 'text', required: true, placeholder: 'ej. Explotación' },
  { name: 'description', label: 'Descripción', type: 'textarea', colSpan: 2 },
  { name: 'sortOrder', label: 'Orden', type: 'number', min: 0, step: 1 },
]

export default function ComponentCategoriesPage() {
  return (
    <CatalogoBasePage<ComponentCategoryItem>
      title="Categorías de Componente"
      subtitle="Agrupan los tipos de componentes por contexto (explotación de un derecho minero vs. beneficio en planta)."
      entityName="categoría de componente"
      service={componentCategoriesService as never}
      columns={columns}
      fields={fields}
      keyExtractor={(c) => c.id}
      idExtractor={(c) => c.id}
      searchPlaceholder="Buscar por código o nombre..."
      defaultValues={{ sortOrder: 99 }}
      createPermission="masters.write"
      updatePermission="masters.write"
      deletePermission="masters.write"
    />
  )
}
